









import _ from "lodash";
import { UIModel } from "../../UIModel";
import { Prop, Component, Vue, Ref } from "vue-property-decorator";
import { BIM360IssueStatus, BIM360Issue } from '@/model/BIM360Issue';
import { FrontendBIM360Issue } from '@/model/frontend/FrontendBIM360Issue';
import IssueModal from "./issue_modal.vue";

@Component({
	components: {
        IssueModal
    },
})
export default class NewIssueModal extends Vue {
	// Props
    @Prop({ required: true }) public model!: UIModel;
    @Prop({ required: false }) public isDisabled!: boolean;

    @Ref() public modal!: IssueModal;

	// Data

	// Mounted
	public mounted() {
		// Set default status

		
	}

	// Methods
	public open() {
		this.modal.open();
	}
}
